export const ExternalVisibility = {
    DEPARTMENTS: "ExternalVisibility.DEPARTMENTS",
    ALL: "ExternalVisibility.ALL"
};